type ValidUserCredentialType = {
  email: string;
  password: string;
};

const validUsers: ValidUserCredentialType[] = [
  {
    email: "javed@tatvacare.in",
    password: "javed@123",
  },
  {
    email: "pradip@tatvacare.in",
    password: "pradip@123",
  },
];

export default validUsers;
